import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@/app/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}
  getAllOrganization(): Observable<any> {
    return this.http.get(`${this.apiUrl}/organizations`);
  }
  getDetailOrganizations(params: any): Observable<any> {
    const httpParams = new HttpParams({ fromObject: params });
    return this.http.get(`${this.apiUrl}/e-o-i-search-organization`, {
      params: httpParams,
    });
  }
  getDetailOrganizationsPqq(params: any): Observable<any> {
    const httpParams = new HttpParams({ fromObject: params });
    return this.http.get(`${this.apiUrl}/pqq/search/organization`, {
      params: httpParams,
    });
  }
  getTenderingOrganizationsDetails(params: any, projectId: number, moduleType: string|null): Observable<any> {
    // Conditionally append moduleType to the URL if it's not null
    const url = moduleType ?
      `${this.apiUrl}/projects/${projectId}/tendering/search/organization/${moduleType}` :
      `${this.apiUrl}/projects/${projectId}/tendering/search/organization`;
    const httpParams = new HttpParams({ fromObject: params });
  
    return this.http.get(url, {
      params: httpParams,
    });
  }
  
  getLoggedInUserOrganization(): any {
    const orgInfoString = localStorage.getItem('org_info');
    if (orgInfoString) {
      return JSON.parse(orgInfoString); // Converts the string to an object
    }
    return null;
  }

}
